var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[(_vm.loading)?_c('LoaderComponent'):_c('FormComponent',{attrs:{"questions":_vm.questions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }